import { Backdrop, CircularProgress, Portal } from "@mui/material";

const AuthorizationOverlay = ({ open }) => (
  <Portal>
    <Backdrop
      open={open}
      sx={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        color: "#fff",
        zIndex: (theme) => theme.zIndex.modal + 1,
      }}
      aria-label="Waiting for authorization"
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  </Portal>
);

export default AuthorizationOverlay;
